// extracted by mini-css-extract-plugin
export var downArrow = "_8g-0";
export var infoTooltipIcon = "_8g-3";
export var label = "_8g-1";
export var optionCard = "_8g-4";
export var upArrow = "_8g-2";